var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5204 24.7582C47.458 21.5902 46.7716 18.427 45.4996 15.5374C44.2324 12.643 42.394 10.027 40.138 7.86223C37.882 5.69743 35.2084 3.98383 32.314 2.85103C29.4196 1.71823 26.314 1.17583 23.2372 1.23823C20.1652 1.30063 17.1028 1.96783 14.3092 3.20143C11.5108 4.43023 8.97163 6.21103 6.87883 8.39503C4.78123 10.579 3.12523 13.171 2.03563 15.9694C0.941232 18.7678 0.418032 21.7774 0.485232 24.7534C0.547632 27.7294 1.19563 30.6862 2.38603 33.3934C3.57643 36.1006 5.29963 38.5534 7.41643 40.579C9.53323 42.6046 12.0388 44.2078 14.746 45.259C17.4532 46.315 20.362 46.819 23.242 46.7518C26.122 46.6894 28.978 46.0606 31.5892 44.9086C34.2052 43.7566 36.5716 42.0862 38.53 40.0414C40.4884 37.9966 42.0292 35.5726 43.0468 32.9566C43.666 31.3726 44.0836 29.7118 44.3044 28.0366C44.362 28.0414 44.4244 28.0414 44.482 28.0414C46.1572 28.0414 47.5156 26.683 47.5156 25.0078C47.5156 24.9214 47.5108 24.8398 47.506 24.7534L47.5204 24.7582ZM42.6964 32.8174C41.5828 35.3422 39.97 37.627 37.9924 39.5134C36.0148 41.3998 33.6772 42.8878 31.1524 43.867C28.6276 44.8462 25.9252 45.3118 23.242 45.2446C20.5588 45.1822 17.9044 44.5918 15.4756 43.5166C13.0468 42.4414 10.8436 40.8862 9.02923 38.9806C7.21003 37.075 5.77963 34.819 4.84363 32.3854C3.89803 29.947 3.45643 27.3454 3.51883 24.7582C3.58123 22.171 4.15243 19.6174 5.18923 17.2798C6.22603 14.9422 7.72363 12.8254 9.56203 11.0782C11.4004 9.33103 13.57 7.95343 15.9076 7.05583C18.2452 6.15343 20.7508 5.72623 23.2372 5.79343C25.7284 5.85583 28.1812 6.40783 30.4228 7.40623C32.6692 8.40463 34.7044 9.84943 36.3796 11.6158C38.0596 13.3822 39.3748 15.4702 40.2388 17.7166C41.1028 19.963 41.5108 22.3678 41.4436 24.7582H41.4532C41.4484 24.8398 41.4436 24.9262 41.4436 25.0126C41.4436 26.5774 42.6292 27.8638 44.1508 28.027C43.8628 29.6782 43.3732 31.291 42.6964 32.8174Z",
    fill: "url(#paint0_linear_3079_36245)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 24 24",
    to: "360 24 24",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3079_36245",
    x1: 20.2969,
    y1: 2.77606,
    x2: 33.5378,
    y2: 26.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.5ba5dcae66a7cb08393293f887928c34.svg";
export { ForwardRef as ReactComponent };